import FancyInput from './FancyInput';
export default FancyInput;